<template>
  <a-row class="footer">
    <a-col class="container" :xs="{ span: 24, offset: 0 }" :xxl="{ span: 16, offset: 4 }">
      <div class="contact">
        <div class="info">
          <img class="page-logo" src="~@/assets/logo_blue.png" alt="logo">
          <a-descriptions :column="1">
            <a-descriptions-item>
              <span slot="label">
                <a-icon type="phone" theme="filled" style="margin-right: 5px" />电话
              </span>
              028-85038030 / 028-82880293
            </a-descriptions-item>
            <!-- <a-descriptions-item>
              <span slot="label"><a-icon type="mobile" theme="filled" style="margin-right: 5px"/>手机</span>
              15184448007
            </a-descriptions-item> -->
            <a-descriptions-item>
              <span slot="label">
                <a-icon type="environment" theme="filled" style="margin-right: 5px" />地址
              </span>
              成都市高新区天府大道中段东方希望天祥广场530号1栋3005
            </a-descriptions-item>
          </a-descriptions>
        </div>
        <div class="qrcode-group">
          <div class="qrcode">
            <img src="~@/assets/gzh_qrcode.jpg" alt="gzh_qrcode">
            <p>关注公众号</p>
          </div>
          <div class="qrcode">
            <img src="~@/assets/zixun_qrcode.png" alt="zixun_qrcode">
            <p>客服咨询</p>
          </div>
        </div>
      </div>

      <div class="copyright">
        <a-row type="flex" justify="center">
          <a class="link" href="https://yzfuture.cn/views/about/index.html?ap=introdution" target="_blank">关于我们</a>
<!--          <router-link class="link" to="/real-name-assistant/direction" target="_blank">帮助中心</router-link>-->
          <router-link class="link" to="/real-name-assistant/protocol/service" >用户协议</router-link>
          <router-link class="link" to="/real-name-assistant/protocol/privacy" >隐私政策</router-link>
        </a-row>
        <a-row type="flex" justify="center">
          <span class="copyright-item">
            {{ `成都鱼住未来科技有限公司版权所有 ©2019 - ${new Date().getFullYear()}` }}
          </span>
          <span class="copyright-item"><a style="color: #999;" href="http://beian.miit.gov.cn"
              target="_blank">蜀ICP备19014280号</a></span>
        </a-row>
      </div>
    </a-col>
  </a-row>
</template>

<script>
export default {
  name: 'PageFooter',
  components: {},
  data () {
    return {}
  },
  computed: {},
  methods: {}
}
</script>

<style lang="less" scoped>
.footer {
  background-color: #272D41;
  color: #999;

  .contact {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    flex-wrap: wrap;

    .info {
      margin: 20px 0;

      @media (min-width: 1024px) {
        flex: 0 0 50%;
      }

      @media (max-width: 1023px) {
        flex: 0 0 100%;
      }

      .page-logo {
        width: auto;
        height: 50px;
        margin: 30px 0;
      }

      ::v-deep.ant-descriptions-item-label {
        color: #999;
        margin: 0;
      }

      ::v-deep.ant-descriptions-item-content {
        color: #999;
      }
    }

    .qrcode-group {
      display: flex;
      justify-content: flex-start;
      margin: 20px 0;

      @media (min-width: 1024px) {
        flex: 0 0 50%;
      }

      @media (max-width: 1023px) {
        flex: 0 0 100%;
      }

      .qrcode {
        text-align: center;
        padding: 0 20px;
        font-size: 14px;

        img {
          width: 90px;
          height: 90px;
          margin-bottom: 10px;
        }
      }
    }
  }

  .copyright {
    font-size: 14px;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    padding: 20px 0;
    text-align: center;

    .link {
      color: #999;
      width: 80px;
      border-right: 1px solid #999;
      line-height: 10px;
      margin-top: 10px;
      margin-bottom: 30px;
    }

    .link:last-child {
      border-right: none
    }

    .copyright-item {
      margin-right: 10px;
    }
  }
}
</style>
